module.exports = __webpack_public_path__ + "img/ps-78.04315a76.jpg";